<template>
    <div class="schedule-detail__drop-route">
        <el-row>
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="danger" @click="resetFilter()">{{ $t('schedule.reset') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" @click="clear()">{{ $t('common.clear') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openStatistic()">{{ $t('common.statistic') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <BusStatus :data-list="dataList" @updateBusStatus="updateBusStatus"></BusStatus>
                </el-form-item>
            </el-form>
        </el-row>
        <template v-if="isLoaded">
            <el-row class="schedule-detail__count">
                <el-col :span="8">
                    <h4>{{ $t('common.total') }}</h4>
                    {{ totalCount.total }}
                </el-col>
                <el-col :span="8">
                    <h4>{{ $t('common.picked') }}</h4>
                    {{ totalCount.picked }}
                </el-col>
                <el-col :span="8">
                    <h4>{{ $t('common.not_picked') }}</h4>
                    {{ totalCount.notPicked }}
                </el-col>
            </el-row>
            <table class="student-list">
                <tr>
                    <th width="3%">#</th>
                    <th width="10%">
                        <input class="input" type="text" v-model="filter.fullname" :placeholder="$t('common.full_name')"/>
                    </th>
                    <th width="10%">
                        <input class="input" type="text" v-model="filter.romaji" :placeholder="$t('common.romaji')"/>
                    </th>
                    <th width="10%">
                        <input class="input" type="text" v-model="filter.furigana" :placeholder="$t('common.furigana')"/>
                    </th>
                    <th width="10%">
                        <el-select v-model="filter.class_id" multiple collapse-tags :placeholder="$t('common.class')">
                            <el-option
                                    v-for="classItem in masterData.class_list"
                                    :key="classItem.id"
                                    :label="classItem.name"
                                    :value="classItem.id">
                            </el-option>
                        </el-select>
                    </th>

                    <th width="12%">
                        <el-select v-model="filter.place_id" multiple collapse-tags :placeholder="$t('common.bus_stop')">
                            <el-option
                                    v-for="place in masterData.place_list"
                                    :key="place.id"
                                    :label="place.name"
                                    :value="place.id">
                            </el-option>
                        </el-select>
                    </th>
                    <th>{{ $t('common.time') }}</th>
                    <th width="5%">
                        <el-checkbox v-model="checkAll" @change="checkAllTrigger"></el-checkbox>
                        <br/>
                        {{ checkCount }}
                    </th>
                    <th width="12%">
                        {{ $t('common.bus') }}
                    </th>
                    <th width="20%">{{ $t('menu.sub_driver') }}</th>
                </tr>
                <tr v-for="(student, index) in studentList" class="student-list__row" :key="student.id">
                    <td>{{ paginator.from + index }}</td>
                    <td>{{ student.fullname }}</td>
                    <td>{{ student.romaji }}</td>
                    <td>{{ student.furigana }}</td>
                    <td>{{ student.class_name }}</td>
                    <td>{{ student.place_name }}</td>
                    <td>
                        <vue-timepicker
                            :ref="`student_${student.id}`"
                            v-model="studentDataList[student.id].time"
                            auto-scroll
                            manual-input
                            close-on-complete
                            format="HH:mm"
                            placeholder=" ">
                        </vue-timepicker>
                    </td>
                    <td>
                        <el-checkbox
                                v-model="studentDataList[student.id].is_checked">
                        </el-checkbox>
                    </td>
                    <td>
                        <select class="input"
                                v-model="studentDataList[student.id].bus_id"
                                :disabled="!hasTime(studentDataList[student.id].time)">
                            <option value="">{{ $t('common.please_select') }}</option>
                            <option v-for="bus in masterData.bus_list"
                                    :key="bus.id" :value="bus.id">
                                {{ bus.name }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="input"
                                v-model="studentDataList[student.id].sub_driver_id"
                                :disabled="!hasTime(studentDataList[student.id].time)">
                            <option value="">{{ $t('common.please_select') }}</option>
                            <option v-for="subDriver in masterData.sub_driver_list"
                                    :key="subDriver.id" :value="subDriver.id">
                                {{ subDriver.name }}
                            </option>
                        </select>
                    </td>
                </tr>
            </table>

            <div class="mt-3">
                <el-pagination
                    v-show="paginator.total > paginator.perPage"
                    background
                    @current-change="didSelectPage"
                    :page-size="paginator.perPage"
                    layout="prev, pager, next"
                    :current-page="paginator.page"
                    :total="paginator.total">
                </el-pagination>
            </div>
        </template>

        <el-dialog
            :title="$t('common.statistic')"
            :visible.sync="isStatisticOpen"
            width="90%"
            :before-close="closeStatistic">
            <el-row class="statistic-content" :gutter="20">
                <el-col class="statistic-content__col" :span="8" v-for="placeInfo in statistic" :key="placeInfo.id">
                    <h5>{{ placeInfo.name }}</h5>
                    <table>
                        <tr v-for="(classInfo, classId) in sortClass(placeInfo.classList)" :key="classId">
                            <th width="30%">{{ classInfo.name }}</th>
                            <td>{{ classInfo.count }}</td>
                        </tr>
                    </table>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeStatistic">{{ $t('common.cancel') }}</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import VueTimepicker from 'vue2-timepicker'
    import {mapState} from "vuex"
    import BusStatus from "./BusStatus"

    export default {
        name: 'ScheduleDropRoute',
        components: {
            VueTimepicker,
            BusStatus
        },
        data: function () {
            return {
                filter: {
                    fullname: '',
                    furigana: '',
                    class_id: [],
                    place_id: [],
                    romaji: ''
                },
                time:{},
                checked: {},
                checkAll: false,
                studentList: [],
                paginator: {
                    page: null,
                    total: null,
                    perPage: null,
                    from: null
                },
                studentDataList: {},
                ignoreTimeWatchList: [],
                ignoreBusWatchList: [],
                ignoreSubDriverWatchList: [],
                watchers: [],
                retrieveTimeout: null,
                isLoaded: false,
                total: null,
                isStatisticOpen: false,
                statistic: []
            }
        },
        methods: {
            hasTime(time) {
                return time && time.HH && time.mm
            },
            getTimePickerString(value) {
                return `${value.HH}:${value.mm}`
            },
            checkAllTrigger(){
                if (!this.checkAll) {
                    Object.keys(this.studentDataList).forEach((studentId) => {
                        this.studentDataList[studentId].is_checked = false
                    })
                } else {
                    let times = []

                    Object.keys(this.studentDataList).forEach((studentId) => {
                        let studentData = this.studentDataList[studentId]
                        let timeString = this.getTimePickerString(studentData.time)
                        if (studentData.is_checked && times.indexOf(timeString) === -1) {
                            times.push(timeString)
                        }
                    })

                    let callback

                    if (times.length) {
                        callback = (studentData) => {
                            let timeString = this.getTimePickerString(studentData.time)

                            if (times.indexOf(timeString) !== -1) {
                                studentData.is_checked = true
                            }
                        }
                    } else {
                        callback = (studentData) => {
                            if (studentData.bus_id) {
                                studentData.is_checked = true
                            }
                        }
                    }

                    Object.keys(this.studentDataList).forEach((studentId) => {
                        callback(this.studentDataList[studentId])
                    })
                }
            },
            getCheckedIds: function () {
                let checkedIds = []

                for (let id in this.checked) {
                    if (this.checked[id]) {
                        checkedIds.push(parseInt(id))
                    }
                }

                return checkedIds
            },
            resetFilter: function () {
                this.filter = {
                    fullname: '',
                    furigana: '',
                    class_id: [],
                    place_id: [],
                    romaji: ''
                }
            },
            clear: function () {
                this.$store.commit('openConfirm', {
                    title: this.$t('common.confirm'),
                    message: this.$t('common.schedule_clear_confirm'),
                    callback: () => {
                      for( let id_item in  this.studentDataList){
                        if(this.studentDataList[id_item]){
                          this.studentDataList[id_item].time = {
                            HH: '',
                            mm: ''
                          }
                          this.studentDataList[id_item].sub_driver_id = null
                          this.studentDataList[id_item].bus_id = null
                        }
                      }
                        // this.studentDataList.forEach(item => {
                        //     item.time = {
                        //         HH: '',
                        //         mm: ''
                        //     }
                        //     item.sub_driver_id = null
                        //     item.bus_id = null
                        // })

                        this.$emit('clearData')
                    }
                })
            },
            openStatistic: function () {
                this.$store.dispatch('schedule/retrieveStudentMasterListNoFilter', {
                    successCallback: (response) => {
                        let studentList = response.data.student_list
                        let statistic = {}

                        studentList.forEach((item) => {
                            if (item.place_info && item.class_info) {
                                if (typeof statistic[item.place_info.id] === 'undefined') {
                                    statistic[item.place_info.id] = {
                                        id: item.place_info.id,
                                        name: item.place_info.name,
                                        classList: {}
                                    }
                                }

                                if (typeof statistic[item.place_info.id].classList[item.class_info.id] === 'undefined') {
                                    statistic[item.place_info.id].classList[item.class_info.id] = {
                                        id: item.class_info.id,
                                        name: item.class_info.name,
                                        count: 0
                                    }
                                }

                                statistic[item.place_info.id].classList[item.class_info.id].count++
                            }
                        })

                        this.statistic = Object.values(statistic).sort((before, after) => {
                            let beforeName = before.name.toLowerCase()
                            let afterName = after.name.toLowerCase()

                            return beforeName < afterName ? -1 : beforeName > afterName ? 1 : 0
                        })

                        this.isStatisticOpen = true
                    }
                })
            },
            setCheckedData (currentStudentId, callback) {
                Object.keys(this.studentDataList).forEach((studentId) => {
                    if (parseInt(studentId) === parseInt(currentStudentId)) {
                        return
                    }

                    let studentData = this.studentDataList[studentId]

                    if (studentData.is_checked) {
                        callback(studentData)
                    }
                })
            },
            setTimeCheckedData(value, currentStudentId) {
                this.setCheckedData(currentStudentId, (studentData) => {
                    this.setStudentTime(studentData, value)
                })
            },
            setBusCheckedData(value, currentStudentId) {
                this.setCheckedData(currentStudentId, (studentData) => {
                    this.setStudentBus(studentData, value)
                })
            },
            setSubDriverCheckedData(value, currentStudentId) {
                this.setCheckedData(currentStudentId, (studentData) => {
                    this.setStudentSubDriver(studentData, value)
                })
            },
            addIgnoreTimeWatch(studentId) {
                this.ignoreTimeWatchList.push(studentId)
            },
            addIgnoreBusWatch(studentId) {
                this.ignoreBusWatchList.push(studentId)
            },
            addIgnoreSubDriverWatch(studentId) {
                this.ignoreSubDriverWatchList.push(studentId)
            },
            setStudentTime(studentData, value) {
                if (studentData.time === value) {
                    return
                }

                this.addIgnoreTimeWatch(studentData.student_id)
                studentData.time = value
            },
            setStudentBus(studentData, value) {
                if (studentData.bus_id === value) {
                    return
                }

                this.addIgnoreBusWatch(studentData.student_id)
                studentData.bus_id = value
            },
            setStudentSubDriver(studentData, value) {
                if (studentData.sub_driver_id === value) {
                    return
                }

                this.addIgnoreSubDriverWatch(studentData.student_id)
                studentData.sub_driver_id = value
            },
            retrieveStudentList: function (page) {
                this.$store.dispatch('schedule/retrieveTemplateStudentList', {
                    filter: this.filter,
                    page,
                    successCallback: (response) => {
                        this.checkAll = false
                        this.isLoaded = true

                        let studentList = response.data.data.student_list
                        this.studentList = studentList.data
                        this.$emit('updateStudentData2', this.studentList)
                        this.paginator.page = studentList.current_page
                        this.paginator.total = studentList.total
                        this.paginator.perPage = studentList.per_page
                        this.paginator.from = studentList.from
                        // this.total = response.data.metadata.total
                        this.total = studentList.total
                        this.$emit('updateStudentTotal', this.total)

                        this.studentDataList = {}

                        this.watchers.forEach((unwatch) => {
                            unwatch()
                        })

                        this.studentList.forEach((item) => {
                            let studentData = this.dataList[item.id] ? {
                                student_id: this.dataList[item.id].student_id,
                                bus_id: this.dataList[item.id].bus_id,
                                sub_driver_id: this.dataList[item.id].sub_driver_id,
                                time: Object.assign({}, this.dataList[item.id].time),
                                is_checked: false
                            } : {
                                student_id: item.id,
                                bus_id: null,
                                sub_driver_id: null,
                                time: {
                                    HH: '',
                                    mm: ''
                                },
                                is_checked: false
                            }

                            this.$set(this.studentDataList, item.id, studentData)

                            this.$nextTick(() => {
                                this.watchers.push(this.$watch(`studentDataList.${item.id}.time`, function(value) {
                                    let ignoreIndex = this.ignoreTimeWatchList.indexOf(item.id)

                                    if (ignoreIndex > -1) {
                                        this.ignoreTimeWatchList.splice(ignoreIndex, 1)
                                        return
                                    }

                                    let studentData = this.studentDataList[item.id]

                                    if (!this.hasTime(value)) {
                                        this.setStudentBus(studentData, null)
                                        this.setStudentSubDriver(studentData, null)
                                    }

                                    if (studentData.is_checked) {
                                        this.setTimeCheckedData(value, studentData.student_id)
                                    }

                                    this.emitStudentData()
                                }))

                                this.watchers.push(this.$watch(`studentDataList.${item.id}.bus_id`, function(value) {
                                    let ignoreIndex = this.ignoreBusWatchList.indexOf(item.id)

                                    if (ignoreIndex > -1) {
                                        this.ignoreBusWatchList.splice(ignoreIndex, 1)
                                        return
                                    }

                                    let studentData = this.studentDataList[item.id]

                                    if (studentData.is_checked) {
                                        this.setBusCheckedData(value, studentData.student_id)
                                    }

                                    this.emitStudentData()
                                }))

                                this.watchers.push(this.$watch(`studentDataList.${item.id}.sub_driver_id`, function(value) {
                                    let ignoreIndex = this.ignoreSubDriverWatchList.indexOf(item.id)

                                    if (ignoreIndex > -1) {
                                        this.ignoreSubDriverWatchList.splice(ignoreIndex, 1)
                                        return
                                    }

                                    let studentData = this.studentDataList[item.id]

                                    if (studentData.is_checked) {
                                        this.setSubDriverCheckedData(value, studentData.student_id)
                                    }

                                    this.emitStudentData()
                                }))
                            })
                        })
                    }
                })
            },
            emitStudentData: function () {
                this.$emit('updateStudentData', this.studentDataList)
            },
            didSelectPage: function (page) {
                this.retrieveStudentList(page)
            },
            updateBusStatus: function (status) {
                this.$emit('updateBusStatus', status)
            },
            closeStatistic: function () {
                this.isStatisticOpen = false
            },
            sortClass(classList) {
                let sortedClassList = Object.values(classList)
                sortedClassList.sort((before, after) => before.level - after.level)
                return sortedClassList
            }
        },
        computed: {
            ...mapState('schedule', ['masterData']),
            totalCount: function () {
                let total = this.total
                let picked = 0
                Object.values(this.dataList).forEach((item) => {
                    if (item.bus_id) {
                        picked++
                    }
                })

                return {
                    total,
                    picked,
                    notPicked: total - picked
                }
            },
            checkCount: function () {
                let count = 0

                Object.keys(this.studentDataList).forEach((studentId) => {
                    if (this.studentDataList[studentId].is_checked) {
                        count++
                    }
                })

                return count
            }
        },
        mounted() {
            this.$store.dispatch('schedule/retrieveMasterData', {})
            this.retrieveStudentList(this.paginator.page)
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    clearTimeout(this.retrieveTimeout)

                    this.retrieveTimeout = setTimeout(() => {
                        this.retrieveStudentList(1)
                    }, 1000)
                }
            }
        },
        props: ['dataList']
    }
</script>
<style lang="scss">
    .schedule-detail__drop-route {
        .drop-route__color {
            display: block;
            height: 25px;
            margin: 0 auto;
        }

        select:disabled {
            cursor: default;
            color: graytext;
        }
    }
</style>
